import { render } from "./TacticContextStylesItems.vue?vue&type=template&id=d165d45a&scoped=true"
import script from "./TacticContextStylesItems.vue?vue&type=script&lang=js"
export * from "./TacticContextStylesItems.vue?vue&type=script&lang=js"

import "./TacticContextStylesItems.vue?vue&type=style&index=0&id=d165d45a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d165d45a"]])

export default __exports__